<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        :type="settings.context"
        :error="error"
        class="card-ticket card-ticket_corp"
        :placeholder="placeholder"
        :loading="loading"
        @hide-card="$emit('hide-card', 'ticket_corp')"
        @refresh-card="fetchCard('ticket_corp', {}, true)"
    >
        <template #title>{{ name }}</template>

        <template v-if="data && data.length > 0" #content>
            <template-ticket-card
                :data="data"
                :name="name"
                :settings="settings"
                :type="type"
                context="ticket_corp"
            />
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';
import TemplateTicketCard from './TemplateTicketCard.vue';

export default {
    components: {
        LayoutCard,
        TemplateTicketCard,
    },
    mixins: [CardMixin],
    computed: {
        placeholder() {
            return this.$l10n.__('Aucun ticket pour le moment');
        },
    },
};
</script>
